//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function set_reload_date() {
  let origin = `${window.location.origin}${window.location.pathname}`;
  let url = new URL(origin);
  let date = $('.current_date').data('date');
  url.searchParams.append('cal_date', date);
  url.searchParams.append('reload_date', '1');
  history.pushState({}, null, url);
}

import axios from 'axios';
import moment from 'moment';
import NewDate from './NewDate.vue'
import EditDate from './EditDate.vue'
export default {
  name: 'Date',
  components: {
    NewDate,
    EditDate,
  },
  props: {
    expert: String,
    ajax: String,
    handleSuccess: Function,
    // repeat_open: [],
    date: String,
    repeatGroupChecked: false,
  },
  data: function () {
    return {
      loading: true,
      success: false,
      error: false,
      availabilitie: [],
      AvailabilitiesGroepssessies: [],
      AvailabilitiesIndividueels: [],
      bookings: [],
      openNewGroepDate: false,
      openNewOpenDate: false,
      openEditDate: '',
    };
  },
  methods: {
    load: function () {
      this.loading = true;
      axios.get(`${this.ajax}?action=agenda&expert=${this.expert}&date=${this.date}`).then(res => {
        const agenda = res.data;
        this.AvailabilitiesGroepssessies = agenda.availabilities_groepssessies.map(availability => {
          return {
            id: availability.id,
            session: availability.session.title,
            start: availability.start,
            end: availability.end,
          }
        });
        this.AvailabilitiesIndividueels = agenda.availabilities_individueels.map(availability => {
          return {
            id: availability.id,
            session: availability.session.title,
            start: availability.start,
            end: availability.end,
          }
        });
        this.bookings = agenda.bookings;
        this.sessions = agenda.sessions.map(session => {
          return {
            label: session.title,
            code: session.id,
          };
        });
        this.loading = false;
      }).catch(error => {
        console.log(error);
        this.loading = false;
      });
    },
    handleOpenNewOpenDate: function () {
      this.openNewOpenDate = true;
    },
    handleOpenNewGroepDate: function () {
      this.openNewGroepDate = true;
    },
    handleClose: function () {
      this.openNewGroepDate = false;
      this.openNewOpenDate = false;
      set_reload_date();
      this.load();
    },
    handleEditClose: function () {
      this.openEditDate = '';
      set_reload_date();
      this.load();
    },
  },
  watch: {
    date: function () {
      this.load();
    },
  },
  created() {
    this.load();
  },
  filters: {
    date: function (value) {
      const date = moment(String(value));
      date.lang('nl');
      return date.format('dddd D MMMM');
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Agenda/Date.vue